import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Modal from '@medflex/components/stories/Modal';
import Button from '@medflex/components/stories/Button';
import { useTranslation } from 'react-i18next';
import { showSuccessToast, showAlertToast } from '@medflex/components/stories/Toast';
import { TRACKING_ACTIONS, trackEvent } from '@medflex/utils/Tracking';
import useModal from '../hooks/useModal';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';
import useUserProfile from '../hooks/useUserProfile';

const UserTagsDeleteModule = () => {
  const { t } = useTranslation('physician');
  const { userTags, deleteTag } = useUserProfile();
  const [userTagToDelete, setUserTagToDelete] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { close } = useModal();
  const { id } = useLocationSearchParams();
  const history = useHistory();

  const goBack = () => history.goBack();

  useEffect(() => {
    if (!id) close({ modal: 'userTagsDelete', id });
    setUserTagToDelete(userTags[id]);
  }, [close, id, userTags]);

  const handleConfirmDelete = async event => {
    setIsLoading(true);
    try {
      await deleteTag(userTagToDelete.id);
      trackEvent(event);
      setIsLoading(false);
      setUserTagToDelete(null);
      goBack();
      showSuccessToast(t('toasts.user_tags.delete.success.title'), null, {
        toastId: 'snippetDeleteSuccess',
      });
    } catch {
      setIsLoading(false);
      showAlertToast(
        t('toasts.user_tags.delete.failure.title'),
        t('toasts.user_tags.delete.failure.text'),
        {
          toastId: 'tagsDeleteFailed',
        },
      );
    }
  };

  const handleClose = event => {
    goBack();
    trackEvent(event, { zone: 'UserTagsModal', actionText: TRACKING_ACTIONS.CLOSE });
  };

  return (
    <Modal
      title={t('modals.user_tags.delete.title', { tag: userTagToDelete?.value || '' })}
      showCloseButton
      onClickCloseButton={handleClose}
    >
      <div>{t('modals.user_tags.delete.text')}</div>
      <Button
        className="my-6 self-start"
        type="button"
        onClick={handleConfirmDelete}
        isLoading={isLoading}
      >
        {t('modals.user_tags.delete.button')}
      </Button>
    </Modal>
  );
};

export default UserTagsDeleteModule;
